
//This function is to remove the border when you click the button on the navigation bar.
function Remove() {
    var removeBorder = document.querySelector(".uno");
    removeBorder.classList.remove("uno");
    var addBorder = document.querySelector(".due");
    addBorder.classList.add("uno");
  }

export default Remove;